// extracted by mini-css-extract-plugin
module.exports = {"dialogContent":"FSDialog-module--dialogContent--E_fc7","closeDialog":"FSDialog-module--closeDialog--JxMlB"};